
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App'
import { BrowserRouter } from 'react-router-dom';

// the id of the div for render
//let appId = 'quizapp';

window.mount = function (id) {

  let element = document.getElementById(id)
  let questions = element.dataset.questions

  const windowAppId = `${process.env.REACT_APP_WINDOW_APP_ID}` ? `${process.env.REACT_APP_WINDOW_APP_ID}` : 'portfolioMapper';
  const initParams = {};

  initParams.wtRegion = window[windowAppId] && `${window[windowAppId].wtRegion}` && `${window[windowAppId].wtRegion}` !== 'undefined' ? `${window[windowAppId].wtRegion}` : "US";
  initParams.token = window[windowAppId] && `${window[windowAppId].token}` && `${window[windowAppId].token}` !== 'undefined' ? `${window[windowAppId].token}` : "";
  initParams.clientEmail = window[windowAppId] && `${window[windowAppId].clientEmail}` && `${window[windowAppId].clientEmail}` !== 'undefined' ? `${window[windowAppId].clientEmail}` : "unknown@unknown.com";
  initParams.isoCode = window[windowAppId] && `${window[windowAppId].isoCode}` && `${window[windowAppId].isoCode}` !== 'undefined' ? `${window[windowAppId].isoCode}` : "en-US";


  // Get the model details
  initParams.buttontext = element.dataset.buttontext ? JSON.parse(element.dataset.buttontext) : null;

  ReactDOM.render(
    <BrowserRouter>
      <App questions={questions} params={initParams} />
    </BrowserRouter>,
    element
  );

}